import { render, staticRenderFns } from "./statistics-recruitment-residence.vue?vue&type=template&id=23aaa023"
import script from "./statistics-recruitment-residence.vue?vue&type=script&lang=js"
export * from "./statistics-recruitment-residence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports